<template>
  <div class="sliderComp">
    <input class="sliderFromInput" type="number" @input="onChangeFrom" :value="from" :min="min" :max="max">
    <vue-slider
        :show="isShow"
        :value.sync="valueComputed"
        :min="min"
        :max="max"
        ref="slider"
        :bgStyle="bgStyle"
        :tooltipStyle="tooltipStyle"
        :processStyle="processStyle"
        @input="onChange"

    ></vue-slider>
    <input class="sliderToInput" type="number" @input="onChangeTo" :value="to" :min="min" :max="max">
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component/src/vue2-slider.vue'

export default {
  name: 'sliderComp',
  props: {
    min: {
      type: Number,
      default: function () {
        return 0
      }
    },
    max: {
      type: Number,
      default: function () {
        return 100
      }
    },
    value: Array,
    moduleName: String
  },
  data: function () {
    return {
      from: 0,
      to: 0,
      width: '100%',
      bgStyle: {
        'backgroundColor': '#fff',
        'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
      },
      tooltipStyle: {
        'backgroundColor': '#ff8200',
        'borderColor': '#ff8200'
      },
      processStyle: {
        'backgroundColor': '#ff8200'
      }
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  mounted: function () {
  },
  components: {
    vueSlider
  },
  computed: {
    isShow: function () {
      return this.$store.getters[`${this.moduleName}/getShowFilters`]
    },
    valueComputed: function () {
      let val = [this.min, this.max]
      if (this.value) val = this.value
      return val
    }
  },
  methods: {
    onChange (value) {
      this.from = value[0]
      this.to = value[1]
    },
    onChangeFrom (event) {
      this.from = +event.target.value
      this.$refs.slider.setValue([this.from, this.to])
    },
    onChangeTo (event) {
      this.to = +event.target.value
      this.$refs.slider.setValue([this.from, this.to])
    }
  },
  watch: {}
}
</script>

<style scoped lang="scss">
  .sliderComp{
    position: relative;
  }
  .sliderComp .sliderFromInput{
    position: absolute;
    top: 30px;
    left: 8px;
    border: none;
    border-bottom: 2px solid #ff8200;
    text-align: center;
    padding: 5px;
  }
  .sliderComp .sliderToInput{
    position: absolute;
    top: 30px;
    right: 8px;
    border: none;
    border-bottom: 2px solid #ff8200;
    text-align: center;
    padding: 5px;
  }

  @media screen and (max-width: 1140px) {
  }

  @media screen and (max-width: 960px) {
  }

  @media screen and (max-width: 720px) {
  }

  @media screen and (max-width: 540px) {
  }

  @media screen and (max-width: 480px) {
  }

  @media screen and (max-width: 320px) {
  }
</style>
